// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-undef, init-declarations, func-names, no-plusplus */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as cookies from "@kiwicom/cookies"

import session from "./session"
import "../services/intl/momentInit"
import cuckoo from "../services/cuckoo/cuckoo"
import { getLanguageInfo } from "../services/staticData"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-require-imports
require("moment-duration-format")

const langInfo = getLanguageInfo(window.__INITIAL_STATE__)

moment.locale(langInfo.moment)

window.Skypicker = {
  version: "@@version", // Replaced by webpack
  timestamp: "@@timestamp", // Replaced by webpack
  config: {
    dateFormat: langInfo.dateFormat,
    timeFormat: langInfo.timeFormat,
    durationFormat: langInfo.durationFormat,
    direction: document.documentElement.getAttribute("dir"),
  },
  helpers: {
    /**
     * atime: 1356346200   Mon, 24 Dec 2012 10:50:00 GMT
     * dtime: 1356340200   Mon, 24 Dec 2012 09:10:00 GMT
     *
     * diff = 6000 (in seconds)
     * 6000s / 3600 = 1.66666 hour
     *
     * 6000 - 3600 = 2400s rest
     * 2400 / 60 = 40 minutes
     */
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    computeDurationBetweenDates(date1: any, date2: any) {
      let duration

      const diff = Math.abs(date1 - date2) // difference in seconds

      const hours = Math.floor(diff / 3600) // number of "full hours" in the difference
      const minutes = (diff - hours * 3600) / 60 // number of minutes in the last (not full) hour

      duration = `${hours}h`
      if (minutes > 0) {
        duration += `\xA0${minutes}m` // non-breakable space is char 0xa0 (160 dec)
      }

      return duration
    },

    prepareEmptyTrip() {
      return {
        compute: {
          durationInSeconds: 0,
          durationInHours: 0,
          durationInHoursRemainingMinutes: 0,
        },
        departure: null,
        arrival: null,
        duration: null,
        stops: 0,
        flights: [],
      }
    },
  },
}

// Currency
// --------
cookies.save("preferred_currency", window.SP_GLOBALS.SKYPICKER_CURRENCY)

// Shim: Google maps
// ===
/**
 * get bounds for polygon - this function existed in api v2 but it's missing in v3
 */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/prefer-optional-chain
if (window.google && window.google.maps && !window.google.maps.Polygon.prototype.getBounds) {
  window.google.maps.Polygon.prototype.getBounds = function () {
    const bounds = new google.maps.LatLngBounds()
    const paths = this.getPaths()
    let path
    for (let p = 0; p < paths.getLength(); p++) {
      path = paths.getAt(p)
      for (let i = 0; i < path.getLength(); i++) {
        bounds.extend(path.getAt(i))
      }
    }
    return bounds
  }
}

// Config: Cuckoo
// ==============
cuckoo.identify(session.userId)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
document.body.className += ` ${window.SP_GLOBALS.SKYPICKER_LNG}`

// EXPOSE
// ======
export default Skypicker.config
